import { Product, Variant, VariantGroup } from "../../types/types";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";
import { isFutureRelease } from "../../utils/variant/isFutureRelease";
import { hasAnyStock } from "@/utils/product/hasAnyStock";

export function promotionalMessagesToShow(
  product: Product,
  selectedVariant: Variant,
  isVariantSelected: boolean,
  selectedVariantGroup?: VariantGroup,
) {
  if (isVariantSelected)
    return getCorrectPromotionalMessaging(
      selectedVariant.messaging || [],
      isVariantUnavailable(selectedVariant),
    );
  else if (selectedVariantGroup)
    return getCorrectPromotionalMessaging(
      selectedVariantGroup.messaging || [],
      isVariantGroupUnavailable(selectedVariantGroup, product),
    );
  else
    return getCorrectPromotionalMessaging(
      product.messaging || [],
      isProductUnavailable(product),
    );
}

interface MonthNumberMap {
  [key: string]: number;
}

export const monthNumberMap: MonthNumberMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

const getCorrectPromotionalMessaging = (
  messaging: (NonPromotionalMessage | PromotionalMessage)[],
  isUnavailable: boolean,
) => {
  return messaging.filter((message) => {
    const pricingGroups = [
      "Save",
      "Reduced To Clear",
      "Special Buy",
      "Price Match",
      "Introductory Offer",
    ];

    if (isUnavailable) {
      return (
        (message as PromotionalMessage).promotionGroup !== undefined &&
        !pricingGroups.includes((message as PromotionalMessage).promotionGroup)
      );
    }
    return (message as PromotionalMessage).promotionGroup !== undefined;
  });
};

const isVariantUnavailable = (selectedVariant: Variant) => {
  const variantIsUnavailable =
    !selectedVariant.availability?.availableToOrder &&
    !isInStoreOnly(selectedVariant) &&
    !isFutureRelease(selectedVariant);

  return variantIsUnavailable;
};

const isVariantGroupUnavailable = (
  selectedVariantGroup: VariantGroup,
  product: Product,
) => {
  const groupVariants = getVariantsForGroup(
    selectedVariantGroup as VariantGroup,
    product,
  );

  const variantGroupIsAvailable = groupVariants.some(
    (v) =>
      v.availability?.availableToOrder ||
      v.availability?.unavailableReason === "inStoreOnly" ||
      v.availability?.unavailableReason === "notYetAvailable",
  );
  return !variantGroupIsAvailable;
};

const isProductUnavailable = (product: Product) => {
  const productUnavailable = !hasAnyStock(product);
  return productUnavailable;
};

function getVariantsForGroup(variantGroup: VariantGroup, product: Product) {
  const groupVariantIds = variantGroup.variants.map((v) => v.id);
  const allVariants: Variant[] = product.variants;
  const groupVariants = allVariants.filter((v) =>
    groupVariantIds.includes(v.id),
  );
  return groupVariants;
}
